/**
 * Product Badge Mobile Positioning
 * 
 * Gère le positionnement du badge produit :
 * - Desktop : affichage normal dans le flux
 * - Mobile : positionnement en bas à gauche de la galerie média
 */

class ProductBadgeManager {
  constructor(badgeId) {
    this.badgeId = badgeId;
    this.badge = document.querySelector(`.product-badge[data-block-id="${badgeId}"]`);
    this.galleryWrapper = document.querySelector('.product-gallery__media-list-wrapper');
    this.productInfo = document.querySelector('.product-info');
    this.resizeTimer = null;
    
    if (this.badge) {
      this.init();
    }
  }

  init() {
    this.handleBadgePosition();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.handleBadgePosition();
      }, 150);
    });
  }

  isMobile() {
    return window.innerWidth < 1000;
  }

  handleBadgePosition() {
    if (this.isMobile() && this.galleryWrapper) {
      this.moveToGallery();
    } else {
      this.removeFromGallery();
    }
  }

  moveToGallery() {
    // Vérifier si le badge n'est pas déjà dans la galerie
    const existingBadge = this.galleryWrapper.querySelector(`.product-badge[data-block-id="${this.badgeId}"]`);
    
    if (!existingBadge && this.badge) {
      const badgeClone = this.badge.cloneNode(true);
      this.galleryWrapper.appendChild(badgeClone);
    }
  }

  removeFromGallery() {
    if (this.galleryWrapper) {
      const galleryBadge = this.galleryWrapper.querySelector(`.product-badge[data-block-id="${this.badgeId}"]`);
      if (galleryBadge) {
        galleryBadge.remove();
      }
    }
  }
}

// Auto-initialisation pour tous les badges produit
document.addEventListener('DOMContentLoaded', () => {
  const badges = document.querySelectorAll('.product-badge[data-block-id]');
  
  badges.forEach(badge => {
    const blockId = badge.getAttribute('data-block-id');
    if (blockId) {
      new ProductBadgeManager(blockId);
    }
  });
});

// Export pour utilisation externe si nécessaire
window.ProductBadgeManager = ProductBadgeManager;
